// extracted by mini-css-extract-plugin
module.exports = {"FaqAskQuestion":"ox_a bho_px bho_a bho_w","FaqAskQuestion__outdated":"ox_b bho_ul bho_vz"};